var TopUpTypes;
(function (TopUpTypes) {
    TopUpTypes["BankTransfer"] = "BANK_TRANSFER";
    TopUpTypes["PayWithCard"] = "PAYMENTS";
})(TopUpTypes || (TopUpTypes = {}));
export default TopUpTypes;
